import produce from 'immer'
import { ActionType, getType } from 'typesafe-actions'

import {
  fetchCoverageByDateRangeAction,
  setIsCoverageStaleAction,
} from './actions'
import { CoverageState } from './coverage.types'
import { emptyNormalizedCoverageData } from './coverage.utils'

export const initialState: CoverageState = {
  data: {},
  isStale: false,
}

const actions = {
  fetchCoverageByDateRangeAction,
  setIsCoverageStaleAction,
}

type TicketCommentActionsTypes = ActionType<typeof actions>

export const coverageReducer = (
  state = initialState,
  action: TicketCommentActionsTypes,
): CoverageState =>
  produce(state, (draft: CoverageState) => {
    switch (action.type) {
      case getType(setIsCoverageStaleAction): {
        draft.isStale = action.payload
        return
      }

      case getType(fetchCoverageByDateRangeAction.success): {
        const normalized =
          action?.payload?.normalized || emptyNormalizedCoverageData
        draft.data = normalized.coverage
        draft.isStale = false

        return
      }
    }
  })
